import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  ADD_CATEGORY,
  DELETE_CATEGORY,
  GET_ALL_CATEGORIES_LIST,
  GET_CATEGORIES,
  GET_CATEGORY_DETAILS,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_STATUS,
} from "helpers/url_helper"

export const getAllCategoriesList = createAsyncThunk(
  GET_ALL_CATEGORIES_LIST,
  async payload => {
    const response = await post(GET_ALL_CATEGORIES_LIST, payload)
    return response
  }
)

export const updateCategoryStatus = createAsyncThunk(
  UPDATE_CATEGORY_STATUS,
  async payload => {
    const response = await patch(UPDATE_CATEGORY_STATUS, payload)
    return response
  }
)

export const deleteCategory = createAsyncThunk(
  DELETE_CATEGORY,
  async payload => {
    const response = await del(DELETE_CATEGORY, payload)
    return response
  }
)

export const addCategory = createAsyncThunk(ADD_CATEGORY, async payload => {
  const response = await formDataPost(ADD_CATEGORY, payload)
  return response
})

export const getCategoryDetails = createAsyncThunk(
  GET_CATEGORY_DETAILS,
  async payload => {
    const response = await post(GET_CATEGORY_DETAILS, payload)
    return response
  }
)

export const updateCategoryDetails = createAsyncThunk(
  UPDATE_CATEGORY,
  async payload => {
    const response = await formDataPut(UPDATE_CATEGORY, payload)
    return response
  }
)

export const getCategories = createAsyncThunk(
  GET_CATEGORIES,
  async ({ isCombo, countryCode } = {}) => {
    const params = new URLSearchParams()
    if (isCombo !== undefined && isCombo !== null) {
      params.set("isCombo", isCombo)
    }
    if (countryCode) {
      params.set("countryCode", countryCode)
    }
    const query = params.toString()
    const categoryUrl = query ? `${GET_CATEGORIES}?${query}` : GET_CATEGORIES
    const response = await get(categoryUrl)
    return response
  }
)

// export const getCategories = createAsyncThunk(GET_CATEGORIES, async isCombo => {
//   const categoryUrl = isCombo ? `${GET_CATEGORIES}/${isCombo}` : GET_CATEGORIES
//   const response = await get(categoryUrl)
//   return response
// })
